module.exports = __webpack_public_path__ + "static/media/brand4.3b71d7f5.png";